export const SET_ALL_EXECUTIVES = "SET_ALL_EXECUTIVES";

export const GET_EXECUTIVES_FROM_COMPANY = "GET_EXECUTIVES_FROM_COMPANY";
export const SET_COMPANY_EXECUTIVES = "SET_COMPANY_EXECUTIVES";
